export default __webpack_public_path__ + "static/media/ic_danger.010484c9.svg";